import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Button } from '@opendate-app/setlist';

const CreateEntityModal = ({ title, subtitle, placeholder, buttonLabel, initialValue, onSubmit, onClose }) => {
  const [name, setName] = useState(initialValue || '');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleSubmit = () => {
    if (!name.trim() || submitting) return;
    setSubmitting(true);
    onSubmit(name.trim(), () => setSubmitting(false));
  };

  return ReactDOM.createPortal(
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', inset: 0, backgroundColor: 'var(--sl-bg-overlay, rgba(10,13,18,0.7))' }} onClick={onClose} />
      <div style={{ position: 'relative', backgroundColor: 'var(--sl-bg-primary, #fff)', border: '1px solid var(--sl-border-primary, #D5D7DA)', borderRadius: 12, padding: '24px', width: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>
        <h5 style={{ fontWeight: 700, marginBottom: 4, color: 'var(--sl-text-primary)' }}>{title}</h5>
        <p className="small mb-3" style={{ color: 'var(--sl-text-secondary)' }}>{subtitle}</p>
        <input
          type="text"
          className="form-control"
          placeholder={placeholder}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSubmit();
            }
          }}
          autoFocus
          disabled={submitting}
        />
        <div className="d-flex justify-content-end mt-3" style={{ gap: 8 }}>
          <Button variant="secondary" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={!name.trim() || submitting}>
            {submitting ? 'Creating...' : buttonLabel}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

CreateEntityModal.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CreateEntityModal;
